export default class {

    Id = null;

    // Старый Id вопроса
    OldId = null;

    // Id вопроса к которому привязан вариант ответа
    QuestionId = null;

    // Текст ответа
    Text = null;

    // Вес ответа
    Weight = null;

    mapFromDto(questionOptionDto) {
        
        if(!questionOptionDto)
            return this;

        this.Id = questionOptionDto.Id;
        this.OldId = questionOptionDto.OldId;
        this.QuestionId = questionOptionDto.QuestionId;
        this.Text = questionOptionDto.Text;
        this.Weight = questionOptionDto.Weight;

        return this;
    }

    isValid = function () {
		var isName = Boolean(this.Text);
		var isWeight = this.Weight !== null && this.Weight !== "";

		return isName && isWeight;
	}

}